<template>
  <div class="tabs_content">
    <PopupWithInput
        @submitAction="_executePopupWithInputAction"
    />

    <section>
      <a :data-title="$gettext('Přenačíst skupiny')" class="tab_button tab_button_refresh title_tooltip"
         @click.stop="getEntities" />

      <div class="status"><h2 v-translate>Skupiny stanic</h2>
        <a
            v-if="isEditable"
            @click.stop="_createNewChannelGroup"
            :title="$gettext('Přidat skupinu stanic')"
            class="add add_expand"
            v-translate>Přidat skupinu stanic</a>
      </div>

      <div class="filter">
        <div class="field_left">
          <search-input input-class="search" v-model="formFields.search" />
        </div>

      </div>

      <div class="scroll-wrapper">
          <div class="table_overflow" id="contentBox" data-table-id="subscribers-channel-groups">
          <table class="vypis vypis_detail parovaci_kody">
            <thead>
            <tr v-if="entities.length > 0">
              <th class="no_padding drag_drop"></th>
              <th class="no_padding checkbox"></th>
              <sorting-table-title
                  v-for="title in tableTitles"
                  :key="title.id"
                  :column="title.column"
                  :sort="getActiveSort(title.column)"
                  @changeSorting="changeSorting"
              >{{ title.name }}
              </sorting-table-title>
              <th class="no_padding edit"></th>
            </tr>
            </thead>
            <tbody>
            <ChannelGroupRow
                :devices="devices"
                :isEditable="isEditable"
                v-for="channelGroup in entities"
                :channel-group="channelGroup"
                :key="channelGroup.id_group"
                :selectedEntities="selectedEntities"
                @input="select"
                @resetChannelGroup="onResetChannelGroup"
                @removeChannelGroup="onRemoveChannelGroup"
                @duplicateChannelGroup="onDuplicateChannelGroup"
                @showChannelGroupDetail="showSubscriberChannelGroupDetail"
            />
            <tr v-if="entities.length === 0">
              <td colspan="5" v-translate>Nebyly nalezeny žádné skupiny stanic.</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
      <list-action-line
          :entities="entities"
          :selected-entities="selectedEntities"
          :multiple-action-options="multipleActionOptions"
          :offset="formFields.offset"
          :limit="formFields.limit"
          :total-count="totalCount"
          table-id="subscribers-channel-groups"
          @select-all="toggleSelectAll"
          @run-multiple-action="_executeMultipleAction"
          @limit="setLimit"
          @offset="setOffset"
          ref="action_line"
      />
    </section>
  </div>
</template>

<script>
import popupWithInput from "@/components/mixins/popup-with-input"
import message from "@/components/mixins/message"
import PopupWithInput from "../../../common/PopupWithInput";
import ChannelGroupRow from "../../devices/detail/ChannelGroupRow"
import links from "../../../mixins/links";
import listActions from "../../../mixins/list-actions";

export default {
  name: "SubscriberDetailChannelGroups",
  components: { PopupWithInput, ChannelGroupRow },
  mixins: [popupWithInput, message, listActions, links],
  props: {
    entity: Object,
    isEditable: Boolean,
  },
  created(ChannelGroupService) {
    this.channelGroupService = ChannelGroupService;
    this.getEntities();
  },
  data() {
    return {
      entities: [],
      totalCount: 0,
      devices: {},
      isLoaded: false,
    }
  },
  computed: {
    tableTitles() {
      // note: cannot be sorted due to internals of channel group collection
      return [
        { id: 1, name: this.$gettext('Název') },
        { id: 2, name: this.$gettext('Typ skupiny') },
        { id: 3, name: this.$gettext('Počet kanálů') },
        { id: 4, name: this.$gettext('Uživatelský profil') },
        { id: 5, name: this.$gettext('Tématická skupina') },
        { id: 6, name: this.$gettext('Přiřazená zařízení') },
        { id: 7, name: this.$gettext('Upraveno') },
      ]
    },
    csvHeaders() {
      return {
        'name': { name: this.$gettext('Název') },
        'type': {
          name: this.$gettext('Typ skupiny'), callback: (entity) => {
            if (entity.type === "tv") {
              return this.$gettext("Televize");
            } else if (entity.type === "radio") {
              return this.$gettext("Rádia");
            } else {
              return this.$gettext("Uživatelská skupina");
            }
          }
        },
        'channel_count': {
          name: this.$gettext('Počet kanálů'), callback: (entity) => {
            return entity.channels.length
          }
        },
        'subscriber_profile_name': { name: this.$gettext('Uživatelský profil') },
        'thematic_group_name': { name: this.$gettext('Tématická skupina') },
        'devices': {
          name: this.$gettext('Přiřazená zařízení'), callback: (entity) => {
            if (entity.device_ids.length === 0) {
              return this.$gettext("Všechna zařízení");
            } else {
              let deviceNames = [];
              for (const idDevice of entity.device_ids) {
                deviceNames.push(this.devices[idDevice]);
              }
              return deviceNames.join(', ');
            }
          }
        },
        'updated_timestamp': {
          name: this.$gettext('Upraveno'), callback: (entity) => {
            return entity.updated_timestamp ? this.$_datetime_format(entity.updated_timestamp) : ''
          }
        },
      }
    },
    multipleActionOptions() {
      return [
        { value: 'choose', text: this.$gettext('Vyberte akci') },
        { value: 'exportCsv', text: this.$gettext('Exportovat do CSV') },
        { value: 'delete-multi', text: this.$gettext('Smazat') }
      ];
    },
  },
  methods: {
    getEntities() {
      const params = { ...this.getFormFields() }

      this.isLoaded = false;
      this.setLoadingMessage();

      return this.channelGroupService.getEntitiesBySubscriberId(this.entity.id, params)
          .then((response) => {
            this.emptyMessage();
            this.entities = response.channel_groups;
            this.totalCount = response.totalCount;
            this.devices = response.devices;
          });
    },
    _createNewChannelGroup() {
      this.$router.push({
        name: 'createSubscriberChannelGroup',
        params: {
          idSubscriber: this.entity.id
        }
      });
    },
    onDuplicateChannelGroup(channelGroup) {
      let duplicatedName = channelGroup.name + ' (' + this.$gettext('kopie') + ')';

      this.showPopupWithInput("duplicate-channel-group", this.$gettext("Zadejte název nové duplikované skupiny:"), this.$gettext("Duplikovat"), duplicatedName, channelGroup);
    },
    onResetChannelGroup(id, showPopup = true) {
      if (showPopup) {
        this.showPopup(id, 'reset', 'reset-channel-group', null, this.$gettext('Opravdu si přejete resetovat skupinu kanálů?'));
      } else {
        this._removeChannelGroup(id);
      }
    },
    onRemoveChannelGroup(id, showPopup = true) {
      if (showPopup) {
        this.showPopup(id, 'delete', 'delete-channel-group');
      } else {
        this._removeChannelGroup(id);
      }
    },
    _removeChannelGroup(id) {
      this.setLoadingMessage();
      this.channelGroupService.deleteEntity(id, { id_selected_operator: this.$_loggedUser_selectedOperatorId })
          .then(() => {
            this.setSuccessMessage();
            return this.getEntities();
          }).catch((error) => {
        this.$emit('getEntity');
        this.setErrorMessage(this._processDetailErrorMessage(error));
      });
    },
    _executePopupWithInputAction(action, inputValue, data) {
      if (action === 'duplicate-channel-group') {
        this._createDuplicatedChannelGroup(data, inputValue);
      }
    },
    _createDuplicatedChannelGroup(channelGroup, newChannelGroupName) {
      let newChannelGroup = {
        id_subscriber: this.entity.id,
        name: newChannelGroupName,
        device_ids: [...channelGroup.device_ids],
        channel_ids: channelGroup.channels.map((channel) => channel.id)
      }

      this.createChannelGroup(newChannelGroup);
    },
    createChannelGroup(newChannelGroup) {
      this.setLoadingMessage();
      this.channelGroupService.createEntity(newChannelGroup).then(() => {
        this.setSuccessMessage();
        this.getEntities();
      }).catch((error) => {
        this.setErrorMessage(this._processDetailErrorMessage(error));
      });
    },
    _executeMultipleAction(action, activeKey) {
      let actionIds = this.selectedEntities.join();
      switch (action) {
        case 'delete-multi':
          this.onRemoveChannelGroup(actionIds);
          break;
        default:
          this.executeMultipleAction(action, activeKey);
      }
    },
    _exportCsv() {
      this.setLoadingMessage()
      const params = { ...this.getFormFields() }
      delete params.limit;
      delete params.offset;
      return this.channelGroupService.getEntitiesBySubscriberId(this.entity.id, params).then((data) => {
        this._createExportCsv(this.csvHeaders, data['channel_groups']);
      })
    },
    _getCsvData(entities, header){
      let response = [];
      let timeColumns = ['timestamp', 'date_created', 'timestamp_created', 'date_updated', 'timestamp_updated'];
      let filterArray = this.selectedEntities.map(str => { return Number(str)});
      for(const key in entities){
        let entity = entities[key];
        if(filterArray.length > 0 && !filterArray.includes(Number(entity.id_group))){
          continue;
        }
        let line = [];
        for(const columnName in header){
          let columnValue;
          if(timeColumns.includes(columnName)){
            columnValue = entity[columnName] ? this.$_datetime_format(entity[columnName]) : '';
          }else if(header[columnName].hasOwnProperty('callback')){
            try {
              columnValue = header[columnName].callback(entity, key, columnName);
            }catch (error){
              columnValue = '';
            }
          }else {
            if(entity[columnName] !== null && entity[columnName] !== undefined) {
              columnValue = String(entity[columnName]);
            }else{
              columnValue = '';
            }
          }
          line.push(columnValue? '"'+columnValue+'"' : '""');
        }
        response.push(line);
      }

      return this._getCsvFormatDataFromArray(response);
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/views/subscribers/channelGroups/ChannelGroups.vue